import "simplebar";

export const shopModal = () => {
  if (document.querySelector(".js-shop-modal") === null) {
    return;
  }

  const modal = document.querySelector(".js-shop-modal");
  const modalContent = document.querySelector(".js-shop-modal-content");
  const modalCloseBtns = document.querySelectorAll(".js-shop-modal-close");
  const modalOpenBtns = document.querySelectorAll(".js-shop-modal-open");

  const handleModalClose = () => {
    document.body.classList.remove("is-modal-open");
    modal.classList.remove("is-active");
    modalContent.classList.remove("is-active");
  };

  modalOpenBtns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      document.body.classList.add("is-modal-open");
      modal.classList.add("is-active");
      modalContent.classList.add("is-active");
    });
  });

  modal.addEventListener("click", (e) => {
    if (e.target.classList.contains("js-shop-modal")) {
      handleModalClose();
    }
  });

  modalCloseBtns.forEach((btn) => {
    btn.addEventListener("click", handleModalClose);
  });
};
